import { render, staticRenderFns } from "./WorkspaceIcon.vue?vue&type=template&id=116eab36&scoped=true&"
import script from "./WorkspaceIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WorkspaceIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116eab36",
  null
  
)

export default component.exports